import t from "react";
import p from "./index.es54.js";
import "./index.es44.js";
import r from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import "./index.es50.js";
import "./index.es51.js";
const h = ({
  regions: o,
  includeAddButton: i,
  onChange: n,
  onAddClick: l = () => {
  }
}) => {
  const m = (e) => () => {
    n(o.filter((c) => c !== e));
  }, a = () => {
    l();
  };
  return /* @__PURE__ */ t.createElement(p, null, o.map((e) => /* @__PURE__ */ t.createElement(
    r,
    {
      isSmall: !0,
      title: "Fjern sted",
      key: `comparison-region-${e.regionCode}`,
      onClick: m(e),
      iconName: "close"
    },
    e.name
  )), i && /* @__PURE__ */ t.createElement(
    r,
    {
      isSmall: !0,
      onClick: a,
      styleType: "secondary",
      iconName: "plus-circle"
    },
    "Legg til sted"
  ));
};
export {
  h as default
};
//# sourceMappingURL=index.es55.js.map
